import React from 'react';
import { FileText } from 'lucide-react';

export function DeclarationHero() {
  return (
    <div className="text-center mb-12">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-accessible-red-600/10 rounded-full mb-6">
        <FileText className="w-8 h-8 text-accessible-red-600" aria-hidden="true" />
      </div>
      <h1 className="heading-1 mb-4">
        Deklaracja dostępności
      </h1>
      <p className="body-large max-w-3xl mx-auto">
        Fundacja Znajdki zobowiązuje się zapewnić dostępność strony internetowej zgodnie z ustawą z dnia 4 kwietnia 2019 r. o dostępności cyfrowej stron internetowych i aplikacji mobilnych podmiotów publicznych.
      </p>
    </div>
  );
}